export const mod97 = (string: string): number => {
  let checksum: string = string.slice(0, 2);
  let fragment;
  for (let offset = 2; offset < string.length; offset += 7) {
    fragment = checksum + string.substring(offset, offset + 7);
    checksum = String(parseInt(fragment, 10) % 97);
  }
  return parseInt(checksum);
};
